import { imageAssets } from '../assets/theme/theme';
import { Image } from '@fluentui/react-northstar';

import '../styles/Offline.css';

function Offline() {
    return (
        <div className='container-fluid p-0 layout-container d-flex justify-content-center p-3'>
            <div className='row p-0 m-0 w-100'>
                <div className=' platform-container'>
                    <div className='offline-page'>
                        <div className='row'>
                            <Image src={imageAssets.ariya} className="ariya" />
                        </div>
                    </div>
                    <div className='row text-align'>
                        <h2>
                            You're Offline<br>
                            </br>
                            Connect to Internet
                        </h2>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Offline;